/* import __COLOCATED_TEMPLATE__ from './config-editor-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class ConfigEditorCardComponent extends Component
{
	@action updateName(event)
	{
		this.args.onUpdate({ ...this.args.card, name: event.target.value });
	}

	@action addRow()
	{
		const newRows = [...this.args.card.rows, { links: [] }];
		this.args.onUpdate({ ...this.args.card, rows: newRows });
	}

	@action removeRow(rowIndex)
	{
		const newRows = this.args.card.rows.filter((_, i) => i !== rowIndex);
		this.args.onUpdate({ ...this.args.card, rows: newRows });
	}

	@action updateRow(rowIndex, updatedRow)
	{
		const newRows = [...this.args.card.rows];
		newRows[rowIndex] = updatedRow;
		this.args.onUpdate({ ...this.args.card, rows: newRows });
	}

	@action addLink(rowIndex)
	{
		const newRows = [...this.args.card.rows];
		const newLinks = [...newRows[rowIndex].links, { label: '', type: 'classGroupResults', classGroupId: '', queryParams: { type: '' } }];
		newRows[rowIndex] = { ...newRows[rowIndex], links: newLinks };
		this.args.onUpdate({ ...this.args.card, rows: newRows });
	}

	@action removeLink(rowIndex, linkIndex)
	{
		const newRows = [...this.args.card.rows];
		const newLinks = newRows[rowIndex].links.filter((_, i) => i !== linkIndex);
		newRows[rowIndex] = { ...newRows[rowIndex], links: newLinks };
		this.args.onUpdate({ ...this.args.card, rows: newRows });
	}

	@action updateLink(rowIndex, linkIndex, updatedLink)
	{
		const newRows = [...this.args.card.rows];
		const newLinks = [...newRows[rowIndex].links];
		newLinks[linkIndex] = updatedLink;
		newRows[rowIndex] = { ...newRows[rowIndex], links: newLinks };
		this.args.onUpdate({ ...this.args.card, rows: newRows });
	}
}
